import { Union, Record } from "../fable_modules/fable-library-js.4.29.0/Types.js";
import { uint8_type, bool_type, option_type, record_type, tuple_type, int32_type, lambda_type, class_type, union_type, string_type, array_type, unit_type } from "../fable_modules/fable-library-js.4.29.0/Reflection.js";
import { AdminPanelStats_$reflection, Notification_$reflection, TrackLevel_$reflection, UpdatedTask_$reflection, CompletedTask_$reflection, NewTask_$reflection, Task_$reflection, UpdateCourse_$reflection, NewCourse_$reflection, Course_$reflection, TrackLevelCourse_$reflection, UpdateTrack_$reflection, NewTrack_$reflection, TrackInactiveOverview_$reflection, EnrolledTrack_$reflection, Track_$reflection, AttendanceStatus_$reflection, EventAttendee_$reflection, UpdatedEvent_$reflection, NewEvent_$reflection, MyHistory_$reflection, Event$_$reflection, UpdatedWorkplace_$reflection, NewWorkplace_$reflection, Workplace_$reflection, UpdatedTitle_$reflection, NewTitle_$reflection, Title_$reflection, NewRegion_$reflection, Region_$reflection, Role_$reflection, Session_$reflection, S3UploadFile_$reflection, UpdatedUser_$reflection, User_$reflection, AuditLog_$reflection } from "./SharedModels.jsx";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.29.0/Result.js";
import { UpdateEmailTemplateError_$reflection, UpdateEmailTemplate_$reflection, AddEmailTemplateError_$reflection, NewEmailTemplate_$reflection, GetEmailTemplateError_$reflection, EmailTemplate_$reflection, UserAutomationCountdown_$reflection, RuleExecutionLog_$reflection, UpdateTrackLevelRule_$reflection, NewTrackLevelRule_$reflection, TrackLevelRule_$reflection, UpdateTrackRule_$reflection, NewTrackRule_$reflection, TrackRule_$reflection, DeleteRuleError_$reflection, UpdateRuleError_$reflection, UpdateGlobalRule_$reflection, AddRuleError_$reflection, NewGlobalRule_$reflection, GetRuleError_$reflection, GlobalRule_$reflection } from "./RuleModels.jsx";

export class IAuditApi extends Record {
    constructor(GetAllAuditLogs, GetFromTable, GetFromTableRow) {
        super();
        this.GetAllAuditLogs = GetAllAuditLogs;
        this.GetFromTable = GetFromTable;
        this.GetFromTableRow = GetFromTableRow;
    }
}

export function IAuditApi_$reflection() {
    return record_type("Shared.Api.IAuditApi", [], IAuditApi, () => [["GetAllAuditLogs", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(AuditLog_$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", array_type(AuditLog_$reflection())]], [["ErrorValue", string_type]]])]))], ["GetFromTable", lambda_type(string_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(AuditLog_$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", array_type(AuditLog_$reflection())]], [["ErrorValue", string_type]]])]))], ["GetFromTableRow", lambda_type(tuple_type(string_type, int32_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(AuditLog_$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", array_type(AuditLog_$reflection())]], [["ErrorValue", string_type]]])]))]]);
}

export class GetUserError extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["NotFound"];
    }
}

export function GetUserError_$reflection() {
    return union_type("Shared.Api.GetUserError", [], GetUserError, () => [[]]);
}

export class UpdateUserError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UserNotFound", "WorkplaceNotFound", "TitleNotFound", "InvalidName", "InvalidEmail", "Internal"];
    }
}

export function UpdateUserError_$reflection() {
    return union_type("Shared.Api.UpdateUserError", [], UpdateUserError, () => [[], [], [], [], [], []]);
}

export class UpdateProfilePictureError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "S3UploadError"];
    }
}

export function UpdateProfilePictureError_$reflection() {
    return union_type("Shared.Api.UpdateProfilePictureError", [], UpdateProfilePictureError, () => [[], []]);
}

export class UpdateEnabledStateError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "MissingWorkplace", "IsAdmin"];
    }
}

export function UpdateEnabledStateError_$reflection() {
    return union_type("Shared.Api.UpdateEnabledStateError", [], UpdateEnabledStateError, () => [[], [], []]);
}

export class SetActiveRoleError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotAllowed", "Internal"];
    }
}

export function SetActiveRoleError_$reflection() {
    return union_type("Shared.Api.SetActiveRoleError", [], SetActiveRoleError, () => [[], []]);
}

export class IUserApi extends Record {
    constructor(GetUser, GetAll, GetAllTeachers, UpdateUser, UpdateProfilePicture, GetSession, GetPendingApprovalCount, SetActiveRole) {
        super();
        this.GetUser = GetUser;
        this.GetAll = GetAll;
        this.GetAllTeachers = GetAllTeachers;
        this.UpdateUser = UpdateUser;
        this.UpdateProfilePicture = UpdateProfilePicture;
        this.GetSession = GetSession;
        this.GetPendingApprovalCount = GetPendingApprovalCount;
        this.SetActiveRole = SetActiveRole;
    }
}

export function IUserApi_$reflection() {
    return record_type("Shared.Api.IUserApi", [], IUserApi, () => [["GetUser", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [User_$reflection(), GetUserError_$reflection()], FSharpResult$2, () => [[["ResultValue", User_$reflection()]], [["ErrorValue", GetUserError_$reflection()]]])]))], ["GetAll", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(User_$reflection()), GetUserError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(User_$reflection())]], [["ErrorValue", GetUserError_$reflection()]]])]))], ["GetAllTeachers", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(User_$reflection()), GetUserError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(User_$reflection())]], [["ErrorValue", GetUserError_$reflection()]]])]))], ["UpdateUser", lambda_type(int32_type, lambda_type(UpdatedUser_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [User_$reflection(), UpdateUserError_$reflection()], FSharpResult$2, () => [[["ResultValue", User_$reflection()]], [["ErrorValue", UpdateUserError_$reflection()]]])])))], ["UpdateProfilePicture", lambda_type(S3UploadFile_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [tuple_type(string_type, string_type), UpdateProfilePictureError_$reflection()], FSharpResult$2, () => [[["ResultValue", tuple_type(string_type, string_type)]], [["ErrorValue", UpdateProfilePictureError_$reflection()]]])]))], ["GetSession", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Session_$reflection(), GetUserError_$reflection()], FSharpResult$2, () => [[["ResultValue", Session_$reflection()]], [["ErrorValue", GetUserError_$reflection()]]])]))], ["GetPendingApprovalCount", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [int32_type, unit_type], FSharpResult$2, () => [[["ResultValue", int32_type]], [["ErrorValue", unit_type]]])]))], ["SetActiveRole", lambda_type(option_type(Role_$reflection()), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [User_$reflection(), SetActiveRoleError_$reflection()], FSharpResult$2, () => [[["ResultValue", User_$reflection()]], [["ErrorValue", SetActiveRoleError_$reflection()]]])]))]]);
}

export class GetRegionError extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["NotFound"];
    }
}

export function GetRegionError_$reflection() {
    return union_type("Shared.Api.GetRegionError", [], GetRegionError, () => [[]]);
}

export class AddRegionError extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["Conflict"];
    }
}

export function AddRegionError_$reflection() {
    return union_type("Shared.Api.AddRegionError", [], AddRegionError, () => [[]]);
}

export class UpdateRegionError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "Conflict"];
    }
}

export function UpdateRegionError_$reflection() {
    return union_type("Shared.Api.UpdateRegionError", [], UpdateRegionError, () => [[], []]);
}

export class DeleteRegionError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "HasWorkplaces"];
    }
}

export function DeleteRegionError_$reflection() {
    return union_type("Shared.Api.DeleteRegionError", [], DeleteRegionError, () => [[], []]);
}

export class IRegionApi extends Record {
    constructor(GetRegion, GetAllRegions, GetEnabledRegions, AddRegion, UpdateRegion, DeleteRegion) {
        super();
        this.GetRegion = GetRegion;
        this.GetAllRegions = GetAllRegions;
        this.GetEnabledRegions = GetEnabledRegions;
        this.AddRegion = AddRegion;
        this.UpdateRegion = UpdateRegion;
        this.DeleteRegion = DeleteRegion;
    }
}

export function IRegionApi_$reflection() {
    return record_type("Shared.Api.IRegionApi", [], IRegionApi, () => [["GetRegion", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Region_$reflection(), GetRegionError_$reflection()], FSharpResult$2, () => [[["ResultValue", Region_$reflection()]], [["ErrorValue", GetRegionError_$reflection()]]])]))], ["GetAllRegions", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Region_$reflection()), unit_type], FSharpResult$2, () => [[["ResultValue", array_type(Region_$reflection())]], [["ErrorValue", unit_type]]])]))], ["GetEnabledRegions", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Region_$reflection()), unit_type], FSharpResult$2, () => [[["ResultValue", array_type(Region_$reflection())]], [["ErrorValue", unit_type]]])]))], ["AddRegion", lambda_type(NewRegion_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Region_$reflection(), AddRegionError_$reflection()], FSharpResult$2, () => [[["ResultValue", Region_$reflection()]], [["ErrorValue", AddRegionError_$reflection()]]])]))], ["UpdateRegion", lambda_type(Region_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Region_$reflection(), UpdateRegionError_$reflection()], FSharpResult$2, () => [[["ResultValue", Region_$reflection()]], [["ErrorValue", UpdateRegionError_$reflection()]]])]))], ["DeleteRegion", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, DeleteRegionError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", DeleteRegionError_$reflection()]]])]))]]);
}

export class GetTitleError extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["NotFound"];
    }
}

export function GetTitleError_$reflection() {
    return union_type("Shared.Api.GetTitleError", [], GetTitleError, () => [[]]);
}

export class AddTitleError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Conflict", "InvalidName"];
    }
}

export function AddTitleError_$reflection() {
    return union_type("Shared.Api.AddTitleError", [], AddTitleError, () => [[], []]);
}

export class UpdateTitleError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "Conflict", "InvalidName"];
    }
}

export function UpdateTitleError_$reflection() {
    return union_type("Shared.Api.UpdateTitleError", [], UpdateTitleError, () => [[], [], []]);
}

export class DeleteTitleError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "HasUsers"];
    }
}

export function DeleteTitleError_$reflection() {
    return union_type("Shared.Api.DeleteTitleError", [], DeleteTitleError, () => [[], []]);
}

export class ITitleApi extends Record {
    constructor(GetTitle, GetAllTitles, AddTitle, UpdateTitle, DeleteTitle) {
        super();
        this.GetTitle = GetTitle;
        this.GetAllTitles = GetAllTitles;
        this.AddTitle = AddTitle;
        this.UpdateTitle = UpdateTitle;
        this.DeleteTitle = DeleteTitle;
    }
}

export function ITitleApi_$reflection() {
    return record_type("Shared.Api.ITitleApi", [], ITitleApi, () => [["GetTitle", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Title_$reflection(), GetTitleError_$reflection()], FSharpResult$2, () => [[["ResultValue", Title_$reflection()]], [["ErrorValue", GetTitleError_$reflection()]]])]))], ["GetAllTitles", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Title_$reflection()), unit_type], FSharpResult$2, () => [[["ResultValue", array_type(Title_$reflection())]], [["ErrorValue", unit_type]]])]))], ["AddTitle", lambda_type(NewTitle_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Title_$reflection(), AddTitleError_$reflection()], FSharpResult$2, () => [[["ResultValue", Title_$reflection()]], [["ErrorValue", AddTitleError_$reflection()]]])]))], ["UpdateTitle", lambda_type(UpdatedTitle_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Title_$reflection(), UpdateTitleError_$reflection()], FSharpResult$2, () => [[["ResultValue", Title_$reflection()]], [["ErrorValue", UpdateTitleError_$reflection()]]])]))], ["DeleteTitle", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, DeleteTitleError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", DeleteTitleError_$reflection()]]])]))]]);
}

export class GetWorkplaceError extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["NotFound"];
    }
}

export function GetWorkplaceError_$reflection() {
    return union_type("Shared.Api.GetWorkplaceError", [], GetWorkplaceError, () => [[]]);
}

export class AddWorkplaceError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["RegionNotFound", "Conflict", "MunicipalityEmpty"];
    }
}

export function AddWorkplaceError_$reflection() {
    return union_type("Shared.Api.AddWorkplaceError", [], AddWorkplaceError, () => [[], [], []]);
}

export class UpdateWorkplaceError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["RegionNotFound", "WorkplaceNotFound", "Conflict", "MunicipalityEmpty"];
    }
}

export function UpdateWorkplaceError_$reflection() {
    return union_type("Shared.Api.UpdateWorkplaceError", [], UpdateWorkplaceError, () => [[], [], [], []]);
}

export class DeleteWorkplaceError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "HasUsers"];
    }
}

export function DeleteWorkplaceError_$reflection() {
    return union_type("Shared.Api.DeleteWorkplaceError", [], DeleteWorkplaceError, () => [[], []]);
}

export class IWorkplaceApi extends Record {
    constructor(GetWorkplace, GetWorkplacesByRegion, GetEnabledWorkplacesByRegion, GetAllWorkplaces, GetEnabledWorkplaces, GetWorkplacesForTrack, AddWorkplace, UpdateWorkplace, DeleteWorkplace) {
        super();
        this.GetWorkplace = GetWorkplace;
        this.GetWorkplacesByRegion = GetWorkplacesByRegion;
        this.GetEnabledWorkplacesByRegion = GetEnabledWorkplacesByRegion;
        this.GetAllWorkplaces = GetAllWorkplaces;
        this.GetEnabledWorkplaces = GetEnabledWorkplaces;
        this.GetWorkplacesForTrack = GetWorkplacesForTrack;
        this.AddWorkplace = AddWorkplace;
        this.UpdateWorkplace = UpdateWorkplace;
        this.DeleteWorkplace = DeleteWorkplace;
    }
}

export function IWorkplaceApi_$reflection() {
    return record_type("Shared.Api.IWorkplaceApi", [], IWorkplaceApi, () => [["GetWorkplace", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Workplace_$reflection(), GetWorkplaceError_$reflection()], FSharpResult$2, () => [[["ResultValue", Workplace_$reflection()]], [["ErrorValue", GetWorkplaceError_$reflection()]]])]))], ["GetWorkplacesByRegion", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Workplace_$reflection()), GetWorkplaceError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(Workplace_$reflection())]], [["ErrorValue", GetWorkplaceError_$reflection()]]])]))], ["GetEnabledWorkplacesByRegion", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Workplace_$reflection()), GetWorkplaceError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(Workplace_$reflection())]], [["ErrorValue", GetWorkplaceError_$reflection()]]])]))], ["GetAllWorkplaces", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Workplace_$reflection()), unit_type], FSharpResult$2, () => [[["ResultValue", array_type(Workplace_$reflection())]], [["ErrorValue", unit_type]]])]))], ["GetEnabledWorkplaces", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Workplace_$reflection()), unit_type], FSharpResult$2, () => [[["ResultValue", array_type(Workplace_$reflection())]], [["ErrorValue", unit_type]]])]))], ["GetWorkplacesForTrack", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Workplace_$reflection()), GetWorkplaceError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(Workplace_$reflection())]], [["ErrorValue", GetWorkplaceError_$reflection()]]])]))], ["AddWorkplace", lambda_type(NewWorkplace_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Workplace_$reflection(), AddWorkplaceError_$reflection()], FSharpResult$2, () => [[["ResultValue", Workplace_$reflection()]], [["ErrorValue", AddWorkplaceError_$reflection()]]])]))], ["UpdateWorkplace", lambda_type(UpdatedWorkplace_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Workplace_$reflection(), UpdateWorkplaceError_$reflection()], FSharpResult$2, () => [[["ResultValue", Workplace_$reflection()]], [["ErrorValue", UpdateWorkplaceError_$reflection()]]])]))], ["DeleteWorkplace", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, DeleteWorkplaceError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", DeleteWorkplaceError_$reflection()]]])]))]]);
}

export class GetEventError extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["NotFound"];
    }
}

export function GetEventError_$reflection() {
    return union_type("Shared.Api.GetEventError", [], GetEventError, () => [[]]);
}

export class AddEventError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NegativeMaxAttendees", "EmptyName", "EmptySummary", "EmptyAddress", "InvalidTeacher", "InvalidCourse", "InvalidRegion", "InvalidTime", "InvalidDeadline", "InvalidSecondaryTeacher", "PrimaryTeacherInSecondaryList"];
    }
}

export function AddEventError_$reflection() {
    return union_type("Shared.Api.AddEventError", [], AddEventError, () => [[], [], [], [], [], [], [], [], [], [], []]);
}

export class UpdateEventError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "NegativeMaxAttendees", "EmptyName", "EmptySummary", "EmptyAddress", "InvalidTeacher", "TeacherIsAttendee", "InvalidRegion", "InvalidTime", "InvalidDeadline", "InvalidSecondaryTeacher", "PrimaryTeacherInSecondaryList"];
    }
}

export function UpdateEventError_$reflection() {
    return union_type("Shared.Api.UpdateEventError", [], UpdateEventError, () => [[], [], [], [], [], [], [], [], [], [], [], []]);
}

export class GetEventAttendeesError extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["NotFound"];
    }
}

export function GetEventAttendeesError_$reflection() {
    return union_type("Shared.Api.GetEventAttendeesError", [], GetEventAttendeesError, () => [[]]);
}

export class GetEventAttendeeCountError extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["NotFound"];
    }
}

export function GetEventAttendeeCountError_$reflection() {
    return union_type("Shared.Api.GetEventAttendeeCountError", [], GetEventAttendeeCountError, () => [[]]);
}

export class CheckOwnEventAttendanceError extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["NotFound"];
    }
}

export function CheckOwnEventAttendanceError_$reflection() {
    return union_type("Shared.Api.CheckOwnEventAttendanceError", [], CheckOwnEventAttendanceError, () => [[]]);
}

export class SignUpForEventError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "NotQualified", "EventDeadlineExceeded", "InactiveTrack"];
    }
}

export function SignUpForEventError_$reflection() {
    return union_type("Shared.Api.SignUpForEventError", [], SignUpForEventError, () => [[], [], [], []]);
}

export class RemoveEventAttendeeError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["EventNotFound", "UserNotFound", "UserNotAttending"];
    }
}

export function RemoveEventAttendeeError_$reflection() {
    return union_type("Shared.Api.RemoveEventAttendeeError", [], RemoveEventAttendeeError, () => [[], [], []]);
}

export class UpdateAttendeePriorityError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["EventNotFound", "EventDeadlineExceeded", "UserNotFound", "NegativePriority"];
    }
}

export function UpdateAttendeePriorityError_$reflection() {
    return union_type("Shared.Api.UpdateAttendeePriorityError", [], UpdateAttendeePriorityError, () => [[], [], [], []]);
}

export class DeleteEventError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "HasAttendees"];
    }
}

export function DeleteEventError_$reflection() {
    return union_type("Shared.Api.DeleteEventError", [], DeleteEventError, () => [[], []]);
}

export class FinalizeEventError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "AlreadyFinalized", "EventNotFinished"];
    }
}

export function FinalizeEventError_$reflection() {
    return union_type("Shared.Api.FinalizeEventError", [], FinalizeEventError, () => [[], [], []]);
}

export class CloseSignupError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "EventAlreadyStarted", "NotificationsAlreadySent", "Unauthorized"];
    }
}

export function CloseSignupError_$reflection() {
    return union_type("Shared.Api.CloseSignupError", [], CloseSignupError, () => [[], [], [], []]);
}

export class IEventApi extends Record {
    constructor(Get, GetAll, GetEnabled, GetEnabledForCalendar, GetMy, GetMyUpcoming, GetMyTeaching, GetHistory, GetTaughtBy, GetFromCourse, GetEnabledFromCourse, Add, Update, GetAttendees, CheckOwnAttendance, SignUp, Withdraw, RemoveAttendee, UpdateAttendeePriority, Delete, Finalize, CloseSignup) {
        super();
        this.Get = Get;
        this.GetAll = GetAll;
        this.GetEnabled = GetEnabled;
        this.GetEnabledForCalendar = GetEnabledForCalendar;
        this.GetMy = GetMy;
        this.GetMyUpcoming = GetMyUpcoming;
        this.GetMyTeaching = GetMyTeaching;
        this.GetHistory = GetHistory;
        this.GetTaughtBy = GetTaughtBy;
        this.GetFromCourse = GetFromCourse;
        this.GetEnabledFromCourse = GetEnabledFromCourse;
        this.Add = Add;
        this.Update = Update;
        this.GetAttendees = GetAttendees;
        this.CheckOwnAttendance = CheckOwnAttendance;
        this.SignUp = SignUp;
        this.Withdraw = Withdraw;
        this.RemoveAttendee = RemoveAttendee;
        this.UpdateAttendeePriority = UpdateAttendeePriority;
        this.Delete = Delete;
        this.Finalize = Finalize;
        this.CloseSignup = CloseSignup;
    }
}

export function IEventApi_$reflection() {
    return record_type("Shared.Api.IEventApi", [], IEventApi, () => [["Get", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Event$_$reflection(), GetEventError_$reflection()], FSharpResult$2, () => [[["ResultValue", Event$_$reflection()]], [["ErrorValue", GetEventError_$reflection()]]])]))], ["GetAll", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Event$_$reflection()), unit_type], FSharpResult$2, () => [[["ResultValue", array_type(Event$_$reflection())]], [["ErrorValue", unit_type]]])]))], ["GetEnabled", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Event$_$reflection()), unit_type], FSharpResult$2, () => [[["ResultValue", array_type(Event$_$reflection())]], [["ErrorValue", unit_type]]])]))], ["GetEnabledForCalendar", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Event$_$reflection()), unit_type], FSharpResult$2, () => [[["ResultValue", array_type(Event$_$reflection())]], [["ErrorValue", unit_type]]])]))], ["GetMy", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Event$_$reflection()), unit_type], FSharpResult$2, () => [[["ResultValue", array_type(Event$_$reflection())]], [["ErrorValue", unit_type]]])]))], ["GetMyUpcoming", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Event$_$reflection()), unit_type], FSharpResult$2, () => [[["ResultValue", array_type(Event$_$reflection())]], [["ErrorValue", unit_type]]])]))], ["GetMyTeaching", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Event$_$reflection()), unit_type], FSharpResult$2, () => [[["ResultValue", array_type(Event$_$reflection())]], [["ErrorValue", unit_type]]])]))], ["GetHistory", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [MyHistory_$reflection(), unit_type], FSharpResult$2, () => [[["ResultValue", MyHistory_$reflection()]], [["ErrorValue", unit_type]]])]))], ["GetTaughtBy", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Event$_$reflection()), unit_type], FSharpResult$2, () => [[["ResultValue", array_type(Event$_$reflection())]], [["ErrorValue", unit_type]]])]))], ["GetFromCourse", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Event$_$reflection()), unit_type], FSharpResult$2, () => [[["ResultValue", array_type(Event$_$reflection())]], [["ErrorValue", unit_type]]])]))], ["GetEnabledFromCourse", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Event$_$reflection()), unit_type], FSharpResult$2, () => [[["ResultValue", array_type(Event$_$reflection())]], [["ErrorValue", unit_type]]])]))], ["Add", lambda_type(NewEvent_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Event$_$reflection(), AddEventError_$reflection()], FSharpResult$2, () => [[["ResultValue", Event$_$reflection()]], [["ErrorValue", AddEventError_$reflection()]]])]))], ["Update", lambda_type(int32_type, lambda_type(UpdatedEvent_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Event$_$reflection(), UpdateEventError_$reflection()], FSharpResult$2, () => [[["ResultValue", Event$_$reflection()]], [["ErrorValue", UpdateEventError_$reflection()]]])])))], ["GetAttendees", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(EventAttendee_$reflection()), GetEventAttendeesError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(EventAttendee_$reflection())]], [["ErrorValue", GetEventAttendeesError_$reflection()]]])]))], ["CheckOwnAttendance", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [AttendanceStatus_$reflection(), CheckOwnEventAttendanceError_$reflection()], FSharpResult$2, () => [[["ResultValue", AttendanceStatus_$reflection()]], [["ErrorValue", CheckOwnEventAttendanceError_$reflection()]]])]))], ["SignUp", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [EventAttendee_$reflection(), SignUpForEventError_$reflection()], FSharpResult$2, () => [[["ResultValue", EventAttendee_$reflection()]], [["ErrorValue", SignUpForEventError_$reflection()]]])]))], ["Withdraw", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, RemoveEventAttendeeError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", RemoveEventAttendeeError_$reflection()]]])]))], ["RemoveAttendee", lambda_type(int32_type, lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, RemoveEventAttendeeError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", RemoveEventAttendeeError_$reflection()]]])])))], ["UpdateAttendeePriority", lambda_type(int32_type, lambda_type(int32_type, lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [EventAttendee_$reflection(), UpdateAttendeePriorityError_$reflection()], FSharpResult$2, () => [[["ResultValue", EventAttendee_$reflection()]], [["ErrorValue", UpdateAttendeePriorityError_$reflection()]]])]))))], ["Delete", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, DeleteEventError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", DeleteEventError_$reflection()]]])]))], ["Finalize", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, FinalizeEventError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", FinalizeEventError_$reflection()]]])]))], ["CloseSignup", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, CloseSignupError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", CloseSignupError_$reflection()]]])]))]]);
}

export class GetTrackError extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["NotFound"];
    }
}

export function GetTrackError_$reflection() {
    return union_type("Shared.Api.GetTrackError", [], GetTrackError, () => [[]]);
}

export class GetUserTracksError extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["UserNotFound"];
    }
}

export function GetUserTracksError_$reflection() {
    return union_type("Shared.Api.GetUserTracksError", [], GetUserTracksError, () => [[]]);
}

export class AddTrackError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Conflict", "ValidationFailed", "UploadImageError"];
    }
}

export function AddTrackError_$reflection() {
    return union_type("Shared.Api.AddTrackError", [], AddTrackError, () => [[], [], []]);
}

export class UpdateTrackError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Conflict", "NotFound"];
    }
}

export function UpdateTrackError_$reflection() {
    return union_type("Shared.Api.UpdateTrackError", [], UpdateTrackError, () => [[], []]);
}

export class DeleteTrackError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "HasEnrolledUsers"];
    }
}

export function DeleteTrackError_$reflection() {
    return union_type("Shared.Api.DeleteTrackError", [], DeleteTrackError, () => [[], []]);
}

export class SignUpForTrackError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "TrackDisabled", "AlreadySignedUp", "WorkplaceTrackNotSet"];
    }
}

export function SignUpForTrackError_$reflection() {
    return union_type("Shared.Api.SignUpForTrackError", [], SignUpForTrackError, () => [[], [], [], []]);
}

export class SignOffTrackError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "NotSignedUp"];
    }
}

export function SignOffTrackError_$reflection() {
    return union_type("Shared.Api.SignOffTrackError", [], SignOffTrackError, () => [[], []]);
}

export class DuplicateTrackError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "ValidationFailed"];
    }
}

export function DuplicateTrackError_$reflection() {
    return union_type("Shared.Api.DuplicateTrackError", [], DuplicateTrackError, () => [[], []]);
}

export class ITrackApi extends Record {
    constructor(GetAll, GetAllEnabled, GetMy, GetAccessible, Get, GetForUser, GetMyInactive, Add, Update, Delete, SignUp, SignOff, Duplicate, GetUsersEnrolledInTrack) {
        super();
        this.GetAll = GetAll;
        this.GetAllEnabled = GetAllEnabled;
        this.GetMy = GetMy;
        this.GetAccessible = GetAccessible;
        this.Get = Get;
        this.GetForUser = GetForUser;
        this.GetMyInactive = GetMyInactive;
        this.Add = Add;
        this.Update = Update;
        this.Delete = Delete;
        this.SignUp = SignUp;
        this.SignOff = SignOff;
        this.Duplicate = Duplicate;
        this.GetUsersEnrolledInTrack = GetUsersEnrolledInTrack;
    }
}

export function ITrackApi_$reflection() {
    return record_type("Shared.Api.ITrackApi", [], ITrackApi, () => [["GetAll", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Track_$reflection()), GetTrackError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(Track_$reflection())]], [["ErrorValue", GetTrackError_$reflection()]]])]))], ["GetAllEnabled", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Track_$reflection()), GetTrackError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(Track_$reflection())]], [["ErrorValue", GetTrackError_$reflection()]]])]))], ["GetMy", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(EnrolledTrack_$reflection()), GetTrackError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(EnrolledTrack_$reflection())]], [["ErrorValue", GetTrackError_$reflection()]]])]))], ["GetAccessible", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Track_$reflection()), GetTrackError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(Track_$reflection())]], [["ErrorValue", GetTrackError_$reflection()]]])]))], ["Get", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Track_$reflection(), GetTrackError_$reflection()], FSharpResult$2, () => [[["ResultValue", Track_$reflection()]], [["ErrorValue", GetTrackError_$reflection()]]])]))], ["GetForUser", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(EnrolledTrack_$reflection()), GetUserTracksError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(EnrolledTrack_$reflection())]], [["ErrorValue", GetUserTracksError_$reflection()]]])]))], ["GetMyInactive", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(TrackInactiveOverview_$reflection()), GetUserTracksError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(TrackInactiveOverview_$reflection())]], [["ErrorValue", GetUserTracksError_$reflection()]]])]))], ["Add", lambda_type(NewTrack_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Track_$reflection(), AddTrackError_$reflection()], FSharpResult$2, () => [[["ResultValue", Track_$reflection()]], [["ErrorValue", AddTrackError_$reflection()]]])]))], ["Update", lambda_type(UpdateTrack_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Track_$reflection(), UpdateTrackError_$reflection()], FSharpResult$2, () => [[["ResultValue", Track_$reflection()]], [["ErrorValue", UpdateTrackError_$reflection()]]])]))], ["Delete", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, DeleteTrackError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", DeleteTrackError_$reflection()]]])]))], ["SignUp", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [EnrolledTrack_$reflection(), SignUpForTrackError_$reflection()], FSharpResult$2, () => [[["ResultValue", EnrolledTrack_$reflection()]], [["ErrorValue", SignUpForTrackError_$reflection()]]])]))], ["SignOff", lambda_type(int32_type, lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, SignOffTrackError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", SignOffTrackError_$reflection()]]])])))], ["Duplicate", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Track_$reflection(), DuplicateTrackError_$reflection()], FSharpResult$2, () => [[["ResultValue", Track_$reflection()]], [["ErrorValue", DuplicateTrackError_$reflection()]]])]))], ["GetUsersEnrolledInTrack", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(User_$reflection()), GetTrackError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(User_$reflection())]], [["ErrorValue", GetTrackError_$reflection()]]])]))]]);
}

export class AddTrackLevelCourseError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Conflict", "NotFound"];
    }
}

export function AddTrackLevelCourseError_$reflection() {
    return union_type("Shared.Api.AddTrackLevelCourseError", [], AddTrackLevelCourseError, () => [[], []]);
}

export class UpdateTrackLevelCourseError extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["NotFound"];
    }
}

export function UpdateTrackLevelCourseError_$reflection() {
    return union_type("Shared.Api.UpdateTrackLevelCourseError", [], UpdateTrackLevelCourseError, () => [[]]);
}

export class DeleteTrackLevelCourseError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "RelationsExist"];
    }
}

export function DeleteTrackLevelCourseError_$reflection() {
    return union_type("Shared.Api.DeleteTrackLevelCourseError", [], DeleteTrackLevelCourseError, () => [[], []]);
}

export class NewTrackLevelCourse extends Record {
    constructor(TrackLevelId, CourseId) {
        super();
        this.TrackLevelId = (TrackLevelId | 0);
        this.CourseId = (CourseId | 0);
    }
}

export function NewTrackLevelCourse_$reflection() {
    return record_type("Shared.Api.NewTrackLevelCourse", [], NewTrackLevelCourse, () => [["TrackLevelId", int32_type], ["CourseId", int32_type]]);
}

export class ITrackLevelCourseApi extends Record {
    constructor(Add, UpdateOrder, Delete) {
        super();
        this.Add = Add;
        this.UpdateOrder = UpdateOrder;
        this.Delete = Delete;
    }
}

export function ITrackLevelCourseApi_$reflection() {
    return record_type("Shared.Api.ITrackLevelCourseApi", [], ITrackLevelCourseApi, () => [["Add", lambda_type(NewTrackLevelCourse_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [TrackLevelCourse_$reflection(), AddTrackLevelCourseError_$reflection()], FSharpResult$2, () => [[["ResultValue", TrackLevelCourse_$reflection()]], [["ErrorValue", AddTrackLevelCourseError_$reflection()]]])]))], ["UpdateOrder", lambda_type(tuple_type(int32_type, int32_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, UpdateTrackLevelCourseError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", UpdateTrackLevelCourseError_$reflection()]]])]))], ["Delete", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, DeleteTrackLevelCourseError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", DeleteTrackLevelCourseError_$reflection()]]])]))]]);
}

export class CourseError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "Conflict", "RelationsExist"];
    }
}

export function CourseError_$reflection() {
    return union_type("Shared.Api.CourseError", [], CourseError, () => [[], [], []]);
}

export class AddCourseError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Conflict", "UploadImageError"];
    }
}

export function AddCourseError_$reflection() {
    return union_type("Shared.Api.AddCourseError", [], AddCourseError, () => [[], []]);
}

export class UpdateCourseError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "ValidationFailed", "ImageUploadFailed", "Conflict"];
    }
}

export function UpdateCourseError_$reflection() {
    return union_type("Shared.Api.UpdateCourseError", [], UpdateCourseError, () => [[], [], [], []]);
}

export class AddCourseTaskError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "Conflict"];
    }
}

export function AddCourseTaskError_$reflection() {
    return union_type("Shared.Api.AddCourseTaskError", [], AddCourseTaskError, () => [[], []]);
}

export class DeleteCourseTaskError extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["NotFound"];
    }
}

export function DeleteCourseTaskError_$reflection() {
    return union_type("Shared.Api.DeleteCourseTaskError", [], DeleteCourseTaskError, () => [[]]);
}

export class AddNewCourseTaskError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "Conflict"];
    }
}

export function AddNewCourseTaskError_$reflection() {
    return union_type("Shared.Api.AddNewCourseTaskError", [], AddNewCourseTaskError, () => [[], []]);
}

export class ICourseApi extends Record {
    constructor(GetAllCourses, GetCourse, CheckOwnEligibility, CheckUserEligibility, AddCourse, UpdateCourse, DeleteCourse, AddCourseTask, DeleteCourseTask, AddNewCourseTask) {
        super();
        this.GetAllCourses = GetAllCourses;
        this.GetCourse = GetCourse;
        this.CheckOwnEligibility = CheckOwnEligibility;
        this.CheckUserEligibility = CheckUserEligibility;
        this.AddCourse = AddCourse;
        this.UpdateCourse = UpdateCourse;
        this.DeleteCourse = DeleteCourse;
        this.AddCourseTask = AddCourseTask;
        this.DeleteCourseTask = DeleteCourseTask;
        this.AddNewCourseTask = AddNewCourseTask;
    }
}

export function ICourseApi_$reflection() {
    return record_type("Shared.Api.ICourseApi", [], ICourseApi, () => [["GetAllCourses", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Course_$reflection()), CourseError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(Course_$reflection())]], [["ErrorValue", CourseError_$reflection()]]])]))], ["GetCourse", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Course_$reflection(), CourseError_$reflection()], FSharpResult$2, () => [[["ResultValue", Course_$reflection()]], [["ErrorValue", CourseError_$reflection()]]])]))], ["CheckOwnEligibility", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [bool_type, unit_type], FSharpResult$2, () => [[["ResultValue", bool_type]], [["ErrorValue", unit_type]]])]))], ["CheckUserEligibility", lambda_type(int32_type, lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [bool_type, unit_type], FSharpResult$2, () => [[["ResultValue", bool_type]], [["ErrorValue", unit_type]]])])))], ["AddCourse", lambda_type(NewCourse_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Course_$reflection(), AddCourseError_$reflection()], FSharpResult$2, () => [[["ResultValue", Course_$reflection()]], [["ErrorValue", AddCourseError_$reflection()]]])]))], ["UpdateCourse", lambda_type(UpdateCourse_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Course_$reflection(), UpdateCourseError_$reflection()], FSharpResult$2, () => [[["ResultValue", Course_$reflection()]], [["ErrorValue", UpdateCourseError_$reflection()]]])]))], ["DeleteCourse", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, CourseError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", CourseError_$reflection()]]])]))], ["AddCourseTask", lambda_type(int32_type, lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Task_$reflection(), AddCourseTaskError_$reflection()], FSharpResult$2, () => [[["ResultValue", Task_$reflection()]], [["ErrorValue", AddCourseTaskError_$reflection()]]])])))], ["DeleteCourseTask", lambda_type(int32_type, lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Task_$reflection(), DeleteCourseTaskError_$reflection()], FSharpResult$2, () => [[["ResultValue", Task_$reflection()]], [["ErrorValue", DeleteCourseTaskError_$reflection()]]])])))], ["AddNewCourseTask", lambda_type(int32_type, lambda_type(NewTask_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Task_$reflection(), AddNewCourseTaskError_$reflection()], FSharpResult$2, () => [[["ResultValue", Task_$reflection()]], [["ErrorValue", AddNewCourseTaskError_$reflection()]]])])))]]);
}

export class GetTaskError extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["NotFound"];
    }
}

export function GetTaskError_$reflection() {
    return union_type("Shared.Api.GetTaskError", [], GetTaskError, () => [[]]);
}

export class GetUserTasksError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UserNotFound", "Unauthorized"];
    }
}

export function GetUserTasksError_$reflection() {
    return union_type("Shared.Api.GetUserTasksError", [], GetUserTasksError, () => [[], []]);
}

export class AddTaskError extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["Conflict"];
    }
}

export function AddTaskError_$reflection() {
    return union_type("Shared.Api.AddTaskError", [], AddTaskError, () => [[]]);
}

export class UpdateTaskError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Conflict", "NotFound", "EmptyFields"];
    }
}

export function UpdateTaskError_$reflection() {
    return union_type("Shared.Api.UpdateTaskError", [], UpdateTaskError, () => [[], [], []]);
}

export class CompleteCourseTaskError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["TaskNotFound", "CourseNotFound", "UserNotFound", "EventAttendeeNotFound"];
    }
}

export function CompleteCourseTaskError_$reflection() {
    return union_type("Shared.Api.CompleteCourseTaskError", [], CompleteCourseTaskError, () => [[], [], [], []]);
}

export class CompleteTrackLevelTaskError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["TaskNotFound", "TrackLevelNotFound", "UserNotFound"];
    }
}

export function CompleteTrackLevelTaskError_$reflection() {
    return union_type("Shared.Api.CompleteTrackLevelTaskError", [], CompleteTrackLevelTaskError, () => [[], [], []]);
}

export class CompleteTasksForUserError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["TaskNotFound", "UserNotFound"];
    }
}

export function CompleteTasksForUserError_$reflection() {
    return union_type("Shared.Api.CompleteTasksForUserError", [], CompleteTasksForUserError, () => [[], []]);
}

export class RevokeTasksFromUserError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["TaskNotFound", "UserNotFound"];
    }
}

export function RevokeTasksFromUserError_$reflection() {
    return union_type("Shared.Api.RevokeTasksFromUserError", [], RevokeTasksFromUserError, () => [[], []]);
}

export class DeleteCompletionError extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["NotFound"];
    }
}

export function DeleteCompletionError_$reflection() {
    return union_type("Shared.Api.DeleteCompletionError", [], DeleteCompletionError, () => [[]]);
}

export class DeleteTaskError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["TaskStillInUse", "NotFound"];
    }
}

export function DeleteTaskError_$reflection() {
    return union_type("Shared.Api.DeleteTaskError", [], DeleteTaskError, () => [[], []]);
}

export class ITaskApi extends Record {
    constructor(GetAllTasks, Get, GetMyCompleted, GetForUser, Add, Update, CompleteCourseTask, RevokeCourseTask, CompleteTrackLevelTask, RevokeTrackLevelTask, CompleteTasksForUser, RevokeTasksFromUser, DeleteCompletion, Delete) {
        super();
        this.GetAllTasks = GetAllTasks;
        this.Get = Get;
        this.GetMyCompleted = GetMyCompleted;
        this.GetForUser = GetForUser;
        this.Add = Add;
        this.Update = Update;
        this.CompleteCourseTask = CompleteCourseTask;
        this.RevokeCourseTask = RevokeCourseTask;
        this.CompleteTrackLevelTask = CompleteTrackLevelTask;
        this.RevokeTrackLevelTask = RevokeTrackLevelTask;
        this.CompleteTasksForUser = CompleteTasksForUser;
        this.RevokeTasksFromUser = RevokeTasksFromUser;
        this.DeleteCompletion = DeleteCompletion;
        this.Delete = Delete;
    }
}

export function ITaskApi_$reflection() {
    return record_type("Shared.Api.ITaskApi", [], ITaskApi, () => [["GetAllTasks", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Task_$reflection()), GetTaskError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(Task_$reflection())]], [["ErrorValue", GetTaskError_$reflection()]]])]))], ["Get", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Task_$reflection(), GetTaskError_$reflection()], FSharpResult$2, () => [[["ResultValue", Task_$reflection()]], [["ErrorValue", GetTaskError_$reflection()]]])]))], ["GetMyCompleted", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(CompletedTask_$reflection()), unit_type], FSharpResult$2, () => [[["ResultValue", array_type(CompletedTask_$reflection())]], [["ErrorValue", unit_type]]])]))], ["GetForUser", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Task_$reflection()), GetUserTasksError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(Task_$reflection())]], [["ErrorValue", GetUserTasksError_$reflection()]]])]))], ["Add", lambda_type(NewTask_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Task_$reflection(), AddTaskError_$reflection()], FSharpResult$2, () => [[["ResultValue", Task_$reflection()]], [["ErrorValue", AddTaskError_$reflection()]]])]))], ["Update", lambda_type(int32_type, lambda_type(UpdatedTask_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Task_$reflection(), UpdateTaskError_$reflection()], FSharpResult$2, () => [[["ResultValue", Task_$reflection()]], [["ErrorValue", UpdateTaskError_$reflection()]]])])))], ["CompleteCourseTask", lambda_type(int32_type, lambda_type(array_type(int32_type), lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [CompletedTask_$reflection(), CompleteCourseTaskError_$reflection()], FSharpResult$2, () => [[["ResultValue", CompletedTask_$reflection()]], [["ErrorValue", CompleteCourseTaskError_$reflection()]]])]))))], ["RevokeCourseTask", lambda_type(int32_type, lambda_type(array_type(int32_type), lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, CompleteCourseTaskError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", CompleteCourseTaskError_$reflection()]]])]))))], ["CompleteTrackLevelTask", lambda_type(int32_type, lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [CompletedTask_$reflection(), CompleteTrackLevelTaskError_$reflection()], FSharpResult$2, () => [[["ResultValue", CompletedTask_$reflection()]], [["ErrorValue", CompleteTrackLevelTaskError_$reflection()]]])])))], ["RevokeTrackLevelTask", lambda_type(int32_type, lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, CompleteTrackLevelTaskError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", CompleteTrackLevelTaskError_$reflection()]]])])))], ["CompleteTasksForUser", lambda_type(array_type(int32_type), lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Task_$reflection()), CompleteTasksForUserError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(Task_$reflection())]], [["ErrorValue", CompleteTasksForUserError_$reflection()]]])])))], ["RevokeTasksFromUser", lambda_type(array_type(int32_type), lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Task_$reflection()), RevokeTasksFromUserError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(Task_$reflection())]], [["ErrorValue", RevokeTasksFromUserError_$reflection()]]])])))], ["DeleteCompletion", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, DeleteCompletionError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", DeleteCompletionError_$reflection()]]])]))], ["Delete", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, DeleteTaskError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", DeleteTaskError_$reflection()]]])]))]]);
}

export class AddTrackLevelError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Conflict", "NotFound", "EmptyFields"];
    }
}

export function AddTrackLevelError_$reflection() {
    return union_type("Shared.Api.AddTrackLevelError", [], AddTrackLevelError, () => [[], [], []]);
}

export class UpdateTrackLevelError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Conflict", "NotFound", "EmptyFields"];
    }
}

export function UpdateTrackLevelError_$reflection() {
    return union_type("Shared.Api.UpdateTrackLevelError", [], UpdateTrackLevelError, () => [[], [], []]);
}

export class AddTrackLevelTaskError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Conflict", "NotFound"];
    }
}

export function AddTrackLevelTaskError_$reflection() {
    return union_type("Shared.Api.AddTrackLevelTaskError", [], AddTrackLevelTaskError, () => [[], []]);
}

export class DeleteTrackLevelError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "RelationsExist"];
    }
}

export function DeleteTrackLevelError_$reflection() {
    return union_type("Shared.Api.DeleteTrackLevelError", [], DeleteTrackLevelError, () => [[], []]);
}

export class DeleteTrackLevelTaskError extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["NotFound"];
    }
}

export function DeleteTrackLevelTaskError_$reflection() {
    return union_type("Shared.Api.DeleteTrackLevelTaskError", [], DeleteTrackLevelTaskError, () => [[]]);
}

export class NewTrackLevel extends Record {
    constructor(Name, Description, TrackId) {
        super();
        this.Name = Name;
        this.Description = Description;
        this.TrackId = (TrackId | 0);
    }
}

export function NewTrackLevel_$reflection() {
    return record_type("Shared.Api.NewTrackLevel", [], NewTrackLevel, () => [["Name", string_type], ["Description", string_type], ["TrackId", int32_type]]);
}

export class ITrackLevelApi extends Record {
    constructor(Add, Update, Delete, AddTask, DeleteTask, AddRequiredTask, DeleteRequiredTask) {
        super();
        this.Add = Add;
        this.Update = Update;
        this.Delete = Delete;
        this.AddTask = AddTask;
        this.DeleteTask = DeleteTask;
        this.AddRequiredTask = AddRequiredTask;
        this.DeleteRequiredTask = DeleteRequiredTask;
    }
}

export function ITrackLevelApi_$reflection() {
    return record_type("Shared.Api.ITrackLevelApi", [], ITrackLevelApi, () => [["Add", lambda_type(NewTrackLevel_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [TrackLevel_$reflection(), AddTrackLevelError_$reflection()], FSharpResult$2, () => [[["ResultValue", TrackLevel_$reflection()]], [["ErrorValue", AddTrackLevelError_$reflection()]]])]))], ["Update", lambda_type(TrackLevel_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [TrackLevel_$reflection(), UpdateTrackLevelError_$reflection()], FSharpResult$2, () => [[["ResultValue", TrackLevel_$reflection()]], [["ErrorValue", UpdateTrackLevelError_$reflection()]]])]))], ["Delete", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, DeleteTrackLevelError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", DeleteTrackLevelError_$reflection()]]])]))], ["AddTask", lambda_type(tuple_type(int32_type, int32_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Task_$reflection(), AddTrackLevelTaskError_$reflection()], FSharpResult$2, () => [[["ResultValue", Task_$reflection()]], [["ErrorValue", AddTrackLevelTaskError_$reflection()]]])]))], ["DeleteTask", lambda_type(tuple_type(int32_type, int32_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, DeleteTrackLevelTaskError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", DeleteTrackLevelTaskError_$reflection()]]])]))], ["AddRequiredTask", lambda_type(tuple_type(int32_type, int32_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Task_$reflection(), AddTrackLevelTaskError_$reflection()], FSharpResult$2, () => [[["ResultValue", Task_$reflection()]], [["ErrorValue", AddTrackLevelTaskError_$reflection()]]])]))], ["DeleteRequiredTask", lambda_type(tuple_type(int32_type, int32_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, DeleteTrackLevelTaskError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", DeleteTrackLevelTaskError_$reflection()]]])]))]]);
}

export class UpdateNotificationError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "AlreadyMarkedRead", "AlreadyMarkedUnread"];
    }
}

export function UpdateNotificationError_$reflection() {
    return union_type("Shared.Api.UpdateNotificationError", [], UpdateNotificationError, () => [[], [], []]);
}

export class INotificationApi extends Record {
    constructor(GetMy, Update, MarkAllAsRead) {
        super();
        this.GetMy = GetMy;
        this.Update = Update;
        this.MarkAllAsRead = MarkAllAsRead;
    }
}

export function INotificationApi_$reflection() {
    return record_type("Shared.Api.INotificationApi", [], INotificationApi, () => [["GetMy", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Notification_$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", array_type(Notification_$reflection())]], [["ErrorValue", string_type]]])]))], ["Update", lambda_type(Notification_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [Notification_$reflection(), UpdateNotificationError_$reflection()], FSharpResult$2, () => [[["ResultValue", Notification_$reflection()]], [["ErrorValue", UpdateNotificationError_$reflection()]]])]))], ["MarkAllAsRead", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))]]);
}

export class S3Error extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["UploadFailed"];
    }
}

export function S3Error_$reflection() {
    return union_type("Shared.Api.S3Error", [], S3Error, () => [[]]);
}

export class IS3Api extends Record {
    constructor(UploadFile) {
        super();
        this.UploadFile = UploadFile;
    }
}

export function IS3Api_$reflection() {
    return record_type("Shared.Api.IS3Api", [], IS3Api, () => [["UploadFile", lambda_type(S3UploadFile_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, S3Error_$reflection()], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", S3Error_$reflection()]]])]))]]);
}

export class IReportApi extends Record {
    constructor(EventAttendees, Overall) {
        super();
        this.EventAttendees = EventAttendees;
        this.Overall = Overall;
    }
}

export function IReportApi_$reflection() {
    return record_type("Shared.Api.IReportApi", [], IReportApi, () => [["EventAttendees", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(uint8_type), string_type], FSharpResult$2, () => [[["ResultValue", array_type(uint8_type)]], [["ErrorValue", string_type]]])]))], ["Overall", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(uint8_type), string_type], FSharpResult$2, () => [[["ResultValue", array_type(uint8_type)]], [["ErrorValue", string_type]]])]))]]);
}

export class IRuleApi extends Record {
    constructor(GetAllGlobalRules, GetGlobalRule, AddGlobalRule, UpdateGlobalRule, DeleteGlobalRule, GetAllTrackRules, GetTrackRulesForTrack, GetTrackRule, AddTrackRule, UpdateTrackRule, DeleteTrackRule, GetAllTrackLevelRules, GetTrackLevelRulesForLevel, GetTrackLevelRule, AddTrackLevelRule, UpdateTrackLevelRule, DeleteTrackLevelRule, GetExecutionLogs, GetMyAutomationCountdowns, GetAllTemplates, GetTemplate, AddTemplate, UpdateTemplate, GetTriggerTypes, GetActionTypes, GetRecipientTypes) {
        super();
        this.GetAllGlobalRules = GetAllGlobalRules;
        this.GetGlobalRule = GetGlobalRule;
        this.AddGlobalRule = AddGlobalRule;
        this.UpdateGlobalRule = UpdateGlobalRule;
        this.DeleteGlobalRule = DeleteGlobalRule;
        this.GetAllTrackRules = GetAllTrackRules;
        this.GetTrackRulesForTrack = GetTrackRulesForTrack;
        this.GetTrackRule = GetTrackRule;
        this.AddTrackRule = AddTrackRule;
        this.UpdateTrackRule = UpdateTrackRule;
        this.DeleteTrackRule = DeleteTrackRule;
        this.GetAllTrackLevelRules = GetAllTrackLevelRules;
        this.GetTrackLevelRulesForLevel = GetTrackLevelRulesForLevel;
        this.GetTrackLevelRule = GetTrackLevelRule;
        this.AddTrackLevelRule = AddTrackLevelRule;
        this.UpdateTrackLevelRule = UpdateTrackLevelRule;
        this.DeleteTrackLevelRule = DeleteTrackLevelRule;
        this.GetExecutionLogs = GetExecutionLogs;
        this.GetMyAutomationCountdowns = GetMyAutomationCountdowns;
        this.GetAllTemplates = GetAllTemplates;
        this.GetTemplate = GetTemplate;
        this.AddTemplate = AddTemplate;
        this.UpdateTemplate = UpdateTemplate;
        this.GetTriggerTypes = GetTriggerTypes;
        this.GetActionTypes = GetActionTypes;
        this.GetRecipientTypes = GetRecipientTypes;
    }
}

export function IRuleApi_$reflection() {
    return record_type("Shared.Api.IRuleApi", [], IRuleApi, () => [["GetAllGlobalRules", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(GlobalRule_$reflection()), unit_type], FSharpResult$2, () => [[["ResultValue", array_type(GlobalRule_$reflection())]], [["ErrorValue", unit_type]]])]))], ["GetGlobalRule", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [GlobalRule_$reflection(), GetRuleError_$reflection()], FSharpResult$2, () => [[["ResultValue", GlobalRule_$reflection()]], [["ErrorValue", GetRuleError_$reflection()]]])]))], ["AddGlobalRule", lambda_type(NewGlobalRule_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [GlobalRule_$reflection(), AddRuleError_$reflection()], FSharpResult$2, () => [[["ResultValue", GlobalRule_$reflection()]], [["ErrorValue", AddRuleError_$reflection()]]])]))], ["UpdateGlobalRule", lambda_type(UpdateGlobalRule_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [GlobalRule_$reflection(), UpdateRuleError_$reflection()], FSharpResult$2, () => [[["ResultValue", GlobalRule_$reflection()]], [["ErrorValue", UpdateRuleError_$reflection()]]])]))], ["DeleteGlobalRule", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, DeleteRuleError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", DeleteRuleError_$reflection()]]])]))], ["GetAllTrackRules", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(TrackRule_$reflection()), unit_type], FSharpResult$2, () => [[["ResultValue", array_type(TrackRule_$reflection())]], [["ErrorValue", unit_type]]])]))], ["GetTrackRulesForTrack", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(TrackRule_$reflection()), unit_type], FSharpResult$2, () => [[["ResultValue", array_type(TrackRule_$reflection())]], [["ErrorValue", unit_type]]])]))], ["GetTrackRule", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [TrackRule_$reflection(), GetRuleError_$reflection()], FSharpResult$2, () => [[["ResultValue", TrackRule_$reflection()]], [["ErrorValue", GetRuleError_$reflection()]]])]))], ["AddTrackRule", lambda_type(NewTrackRule_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [TrackRule_$reflection(), AddRuleError_$reflection()], FSharpResult$2, () => [[["ResultValue", TrackRule_$reflection()]], [["ErrorValue", AddRuleError_$reflection()]]])]))], ["UpdateTrackRule", lambda_type(UpdateTrackRule_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [TrackRule_$reflection(), UpdateRuleError_$reflection()], FSharpResult$2, () => [[["ResultValue", TrackRule_$reflection()]], [["ErrorValue", UpdateRuleError_$reflection()]]])]))], ["DeleteTrackRule", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, DeleteRuleError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", DeleteRuleError_$reflection()]]])]))], ["GetAllTrackLevelRules", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(TrackLevelRule_$reflection()), unit_type], FSharpResult$2, () => [[["ResultValue", array_type(TrackLevelRule_$reflection())]], [["ErrorValue", unit_type]]])]))], ["GetTrackLevelRulesForLevel", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(TrackLevelRule_$reflection()), unit_type], FSharpResult$2, () => [[["ResultValue", array_type(TrackLevelRule_$reflection())]], [["ErrorValue", unit_type]]])]))], ["GetTrackLevelRule", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [TrackLevelRule_$reflection(), GetRuleError_$reflection()], FSharpResult$2, () => [[["ResultValue", TrackLevelRule_$reflection()]], [["ErrorValue", GetRuleError_$reflection()]]])]))], ["AddTrackLevelRule", lambda_type(NewTrackLevelRule_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [TrackLevelRule_$reflection(), AddRuleError_$reflection()], FSharpResult$2, () => [[["ResultValue", TrackLevelRule_$reflection()]], [["ErrorValue", AddRuleError_$reflection()]]])]))], ["UpdateTrackLevelRule", lambda_type(UpdateTrackLevelRule_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [TrackLevelRule_$reflection(), UpdateRuleError_$reflection()], FSharpResult$2, () => [[["ResultValue", TrackLevelRule_$reflection()]], [["ErrorValue", UpdateRuleError_$reflection()]]])]))], ["DeleteTrackLevelRule", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, DeleteRuleError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", DeleteRuleError_$reflection()]]])]))], ["GetExecutionLogs", lambda_type(int32_type, lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(RuleExecutionLog_$reflection()), unit_type], FSharpResult$2, () => [[["ResultValue", array_type(RuleExecutionLog_$reflection())]], [["ErrorValue", unit_type]]])])))], ["GetMyAutomationCountdowns", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(UserAutomationCountdown_$reflection()), unit_type], FSharpResult$2, () => [[["ResultValue", array_type(UserAutomationCountdown_$reflection())]], [["ErrorValue", unit_type]]])]))], ["GetAllTemplates", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(EmailTemplate_$reflection()), unit_type], FSharpResult$2, () => [[["ResultValue", array_type(EmailTemplate_$reflection())]], [["ErrorValue", unit_type]]])]))], ["GetTemplate", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [EmailTemplate_$reflection(), GetEmailTemplateError_$reflection()], FSharpResult$2, () => [[["ResultValue", EmailTemplate_$reflection()]], [["ErrorValue", GetEmailTemplateError_$reflection()]]])]))], ["AddTemplate", lambda_type(NewEmailTemplate_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [EmailTemplate_$reflection(), AddEmailTemplateError_$reflection()], FSharpResult$2, () => [[["ResultValue", EmailTemplate_$reflection()]], [["ErrorValue", AddEmailTemplateError_$reflection()]]])]))], ["UpdateTemplate", lambda_type(UpdateEmailTemplate_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [EmailTemplate_$reflection(), UpdateEmailTemplateError_$reflection()], FSharpResult$2, () => [[["ResultValue", EmailTemplate_$reflection()]], [["ErrorValue", UpdateEmailTemplateError_$reflection()]]])]))], ["GetTriggerTypes", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(tuple_type(int32_type, string_type)), unit_type], FSharpResult$2, () => [[["ResultValue", array_type(tuple_type(int32_type, string_type))]], [["ErrorValue", unit_type]]])]))], ["GetActionTypes", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(tuple_type(int32_type, string_type)), unit_type], FSharpResult$2, () => [[["ResultValue", array_type(tuple_type(int32_type, string_type))]], [["ErrorValue", unit_type]]])]))], ["GetRecipientTypes", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(tuple_type(int32_type, string_type)), unit_type], FSharpResult$2, () => [[["ResultValue", array_type(tuple_type(int32_type, string_type))]], [["ErrorValue", unit_type]]])]))]]);
}

export class GetAdminPanelError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Unauthorized", "Internal"];
    }
}

export function GetAdminPanelError_$reflection() {
    return union_type("Shared.Api.GetAdminPanelError", [], GetAdminPanelError, () => [[], []]);
}

export class IHomeApi extends Record {
    constructor(GetAdminPanel) {
        super();
        this.GetAdminPanel = GetAdminPanel;
    }
}

export function IHomeApi_$reflection() {
    return record_type("Shared.Api.IHomeApi", [], IHomeApi, () => [["GetAdminPanel", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [AdminPanelStats_$reflection(), GetAdminPanelError_$reflection()], FSharpResult$2, () => [[["ResultValue", AdminPanelStats_$reflection()]], [["ErrorValue", GetAdminPanelError_$reflection()]]])]))]]);
}

//# sourceMappingURL=Api.jsx.map
